import type { VNode } from 'vue'
import type { ComponentPublicInstance } from 'vue'
import { getLocation } from '@/helpers/globals'

/* eslint-disable @typescript-eslint/no-explicit-any */
export function hasOwnProperty<X extends any, Y extends PropertyKey>(
    obj: X,
    prop: Y
): obj is X & Record<Y, unknown> {
    // noinspection SuspiciousTypeOfGuard
    return obj instanceof Object && prop in obj
}

export function logVueError(
    err: unknown,
    vm: ComponentPublicInstance | null,
    info: string
): void {
    const data = {
        component: vm ? JSON.stringify(serializeVm(vm)) : {},
        trace: JSON.stringify({
            name: hasOwnProperty(err, 'name') ? err.name || '' : '',
            message: hasOwnProperty(err, 'message') ? err.message || '' : '',
            trace: hasOwnProperty(err, 'stack') ? err.stack || '' : '',
        }),
        info,
        url: getLocationHref(),
        // version: APP_VERSION,
    }

    /* eslint-disable no-console */
    console.error(err, vm, ...Object.values(data))
}

function serializeVm(vm: ComponentPublicInstance): Record<string, any> {
    return {
        vnode: serializeVnode(vm.$.vnode),
        props: vm.$props,
        // Future: Children are now VNodeNormalizedChildren
        // children:
        //     vm.$.vnode.children && vm.$.vnode.children.map((child) => serializeVm(child)),
    }
}

function serializeVnode(node: VNode): Record<string, any> {
    return {
        // Future: How to get Tag
        // tag: node.tag,
        key: node.key,
        // Future: Children are now VNodeNormalizedChildren
        // children:
        //     node.children &&
        //     node.children.map((node) => {
        //         return serializeVnode(node);
        //     }),
    }
}

export function logErrorEvent(e: ErrorEvent): void {
    let type = 'unknown'
    if (e.target instanceof HTMLElement) {
        type = e.target.nodeName
    }

    const data = {
        component: type,
        trace: JSON.stringify(
            ((error: unknown) => {
                if (error instanceof Error) {
                    return {
                        name: e.error.name,
                        message: e.error.message,
                        trace: e.error.stack || '',
                    }
                }

                return error
            })(e.error)
        ),
        info: `Error: ${e.message} @ File ${e.filename}:${e.lineno}:${e.colno}`,
        url: getLocationHref(),
    }

    /* eslint-disable no-console */
    console.error(e.error, ...Object.values(data))
}

function getLocationHref(): string | undefined {
    const location = getLocation()

    return location ? location.href : undefined
}
